/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import type { TypeActe, Mention, Registre } from '@/types';

export type AssistantContextType = {
  /**
   * Type d'acte sélectionné dans la modale de saisie.
   * Détermine les étapes affichées par l'assistant.
   */
  selectedTypeActe: TypeActe | null;
  setSelectedTypeActe: (typeActe: TypeActe | null) => void;

  /**
   * Données de l'acte en cours de saisie : champs de l'acte et de l'enfant à plat,
   * parent1 / parent2 et filiationInconnueParentN. Mises à jour via `onChange`.
   */
  data: Record<string, any>;
  onChange: any;

  /** Registre sélectionné dans la modale de l'étape 1 */
  selectedRegistre: Partial<Registre> | undefined;
  setSelectedRegistre: (registre: Partial<Registre> | undefined) => void;

  /** Mentions de l'étape 3 (la plus récente en premier) */
  mentions: Mention[];
  setMentions: (mentions: Mention[]) => void;

  /** Erreurs de validation, indexées par étape */
  errors: Record<string, any>;
  setErrors: (errors: Record<string, any>) => void;

  /** Réinitialise l'assistant */
  onReset: () => void;
};

const AssistantContext = React.createContext<AssistantContextType>({
  selectedTypeActe: null,
  setSelectedTypeActe: () => {},
  data: {},
  onChange: () => {},
  selectedRegistre: undefined,
  setSelectedRegistre: () => {},
  mentions: [],
  setMentions: () => {},
  errors: {},
  setErrors: () => {},
  onReset: () => {},
});

export default AssistantContext;
